<div class="quote-step" *ngIf="activeFlow$ | async as activeFlow">
  <lx-urgency-driver *ngIf="urgencyDriverVisible$ | async" [expiryDate]="mostUrgentDiscountExpiryDate$ | async"></lx-urgency-driver>
  <lx-your-course></lx-your-course>
  <ng-container [ngSwitch]="activeFlow">
    <lx-quote-step-adults-extras
      *ngSwitchCase="Flows.Adult"
      [accommodations]="accommodations"
      [accommodationOptional]="accommodationOptional"
      [moreAccommodationsDisclaimerShown]="moreAccommodationsDisclaimerShown"
      [groupedTransfers]="groupedTransfers"
      [insurance]="insurance"
      [professionalImmersionExperience]="professionalImmersionExperience"
    ></lx-quote-step-adults-extras>
    <lx-quote-step-juniors-extras
      *ngSwitchCase="Flows.Junior"
      [premiumAccommodation]="premiumAccommodation"
      [premiumActivities]="premiumActivities"
      [unaccompaniedMinorServices]="unaccompaniedMinorServices"
      [insurance]="insurance"
      [privateLesson]="privateLesson"
      [groupedTransfers]="groupedTransfers"
    ></lx-quote-step-juniors-extras>
  </ng-container>
  <lx-supplements></lx-supplements>
  <lx-prices-disclaimer></lx-prices-disclaimer>
  <lx-quote-step-footer></lx-quote-step-footer>
</div>
